const autoNgTemplateLoaderTemplate1 = require('./auth-logs-view.html');

import controller from './auth-logs-view.controller.js';

export const authLogsView = {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller,
};
